import ApolloClient from 'apollo-boost'
import { InMemoryCache } from 'apollo-cache-inmemory'

import { TOKEN, GRAPHQL_API_BASE_DOMAIN } from '../constants'
import { getLocalItem } from '../../local-client/local-client'

const client = new ApolloClient({
  uri: `${GRAPHQL_API_BASE_DOMAIN}graphql`,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  // onError: () => {},
  request: (operation) => {
    const token = getLocalItem(TOKEN)

    if (
      process.env.REACT_APP_STAGING_OVERRIDE === 'true' &&
      process.env.REACT_APP_NODE_ENV !== 'production'
    ) {
      operation.setContext({
        headers: {
          'override-staging-database': 'true',
          authorization: token ? `Bearer ${token}` : '',
        },
      })
    } else {
      operation.setContext({
        headers: {
          authorization: token ? `Bearer ${token}` : '',
        },
      })
    }
  },
})

export default client
